import React, { useEffect, useState } from 'react';

export default function TypewriterText({
  phrases,
  typingSpeed = 70,
  deletingSpeed = 40,
  pauseDuration = 2200,
  className = '',
}) {
  const [phraseIndex, setPhraseIndex] = useState(0);
  const [displayText, setDisplayText] = useState('');
  const [isDeleting, setIsDeleting] = useState(false);

  useEffect(() => {
    const current = phrases[phraseIndex % phrases.length] ?? '';
    let timeoutId;

    if (!isDeleting && displayText === current) {
      timeoutId = setTimeout(() => setIsDeleting(true), pauseDuration);
    } else if (isDeleting && displayText === '') {
      setIsDeleting(false);
      setPhraseIndex((prev) => (prev + 1) % phrases.length);
    } else {
      const nextLength = isDeleting ? displayText.length - 1 : displayText.length + 1;
      const speed = isDeleting ? deletingSpeed : typingSpeed;
      timeoutId = setTimeout(() => {
        setDisplayText(current.slice(0, nextLength));
      }, speed);
    }

    return () => clearTimeout(timeoutId);
  }, [
    displayText,
    isDeleting,
    phraseIndex,
    phrases,
    typingSpeed,
    deletingSpeed,
    pauseDuration,
  ]);

  return (
    <span className={className} aria-live="polite">
      {displayText}
      <span className="typewriter-cursor" aria-hidden="true" />
    </span>
  );
}
